export class PositionMetadaten {
    // BT-160
    name = ""
    // BT-161
    wert = ""
}
